(() => {
  if (window.__laevaCardSwatchesInit) return;
  window.__laevaCardSwatchesInit = true;

  const scopedNode = (el, root) => {
    if (!el || !root) return el;
    const block = el.closest('.shopify-block');
    if (!block || block === root || !root.contains(block) || block.contains(root)) {
      return el;
    }
    return block;
  };

  const findTitle = (content, galleryNode) => {
    const candidates = [
      content.querySelector('[ref="productTitleLink"]'),
      ...content.querySelectorAll('a.contents'),
      ...content.querySelectorAll('p[role="heading"]'),
      ...content.querySelectorAll('h3, h4, .h4'),
    ].filter(Boolean);

    const link = candidates.find((node) => {
      if (node.closest('.card-gallery, .product-grid-view-zoom-out--details')) return false;
      if (galleryNode && galleryNode.contains(node)) return false;
      return true;
    });

    if (!link) return null;

    const title = scopedNode(link, content);
    if (galleryNode && (title.contains(galleryNode) || galleryNode.contains(title))) {
      return link;
    }
    return title;
  };

  const findGallery = (content) => {
    const el =
      content.querySelector('.card-gallery') ||
      content.querySelector('.product-card-gallery') ||
      content.querySelector('slideshow-component') ||
      content.querySelector('.product-media-container') ||
      content.querySelector('.media-gallery');

    if (!el) return null;

    const gallery = scopedNode(el, content);
    if (!content.contains(gallery) || gallery === content) return el;
    return gallery;
  };

  const placeSwatches = () => {
    document.querySelectorAll('product-swatches.laeva-card-swatches').forEach((swatches) => {
      if (!swatches.querySelector('.laeva-card-swatches__picker')) return;

      const card = swatches.closest('product-card') || swatches.closest('.product-card');
      const content = swatches.closest('.product-card__content') || card || swatches.parentElement;
      if (!content) return;

      const gallery = findGallery(content);
      const title = findTitle(content, gallery);

      const alreadyPlaced = gallery
        ? gallery.nextElementSibling === swatches && (!title || swatches.nextElementSibling === title)
        : title && title.previousElementSibling === swatches;

      if (alreadyPlaced) return;

      if (gallery && title && (gallery.contains(title) || title.contains(gallery))) {
        title.parentNode.insertBefore(swatches, title);
        return;
      }

      if (gallery) {
        gallery.after(swatches);
      }

      if (title) {
        if (gallery) {
          swatches.after(title);
        } else {
          title.parentNode.insertBefore(swatches, title);
        }
      }
    });
  };

  let timer;
  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(placeSwatches, 40);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeSwatches, { once: true });
  } else {
    placeSwatches();
  }

  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:reorder', schedule);

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
